import { render, staticRenderFns } from "./Carteira.vue?vue&type=template&id=03273ff0"
import script from "./Carteira.vue?vue&type=script&lang=ts"
export * from "./Carteira.vue?vue&type=script&lang=ts"
import style0 from "./Carteira.vue?vue&type=style&index=0&id=03273ff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports